import { render, staticRenderFns } from "./m-section-newsletter.vue?vue&type=template&id=5760ae39&scoped=true&"
import script from "./m-section-newsletter.vue?vue&type=script&lang=js&"
export * from "./m-section-newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760ae39",
  null
  
)

export default component.exports